import { createFileRoute, useParams } from '@tanstack/react-router';

import { CourseAboutView } from '@/views/courses/detail/course-about-view.tsx';
import { useCourse } from '@/views/courses/detail/course-data.ts';
import { EmptyState } from '@/components/ui.tsx';

export const Route = createFileRoute('/_learner/courses_/$id/about')({
  component: AboutTab,
});

function AboutTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/about' });
  // 复用布局已填充的缓存条目（相同查询 key）。
  const { data: course, isPending, isError } = useCourse(id);

  if (isPending) return <AboutSkeleton />;
  if (isError || !course) return <EmptyState>Could not load course details.</EmptyState>;
  return <CourseAboutView course={course} />;
}

function AboutSkeleton() {
  return (
    <div className="max-w-4xl space-y-8" aria-hidden>
      {[0, 1].map((i) => (
        <div key={i} className="space-y-3 rounded-xl border border-neutral-200 bg-white p-6">
          <div className="h-4 w-32 animate-pulse rounded bg-neutral-100" />
          <div className="h-4 w-full animate-pulse rounded bg-neutral-100" />
          <div className="h-4 w-2/3 animate-pulse rounded bg-neutral-100" />
        </div>
      ))}
    </div>
  );
}
